/* Loop 2 R15: "Ask for the datasheet" in the product Documents block (snippets/product-docs.liquid).
   Adds "Please send the datasheet" as the line note (it.n, R7) on this product's imm_quote line; adds the
   product to the list first when it is not there. Same storage and drawer as R3; no tracking event here. */
(function () {
  var NOTE = 'Please send the datasheet';
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-imm-docask]');
    if (!b || !window.immQuoteRender) return;   // without the drawer the link opens the quote form
    e.preventDefault();
    var a; try { a = JSON.parse(localStorage.getItem('imm_quote')) || []; } catch (err) { a = []; }
    var u = b.getAttribute('data-u'), it = null;
    for (var i = 0; i < a.length; i++) if (a[i].u === u) { it = a[i]; break; }
    if (!it) { it = { t: b.getAttribute('data-t'), u: u, i: b.getAttribute('data-i'), v: b.getAttribute('data-v'), p: b.getAttribute('data-p'), q: 1 }; a.push(it); }
    if (String(it.n || '').toLowerCase().indexOf('datasheet') < 0) it.n = (it.n ? it.n + '; ' : '') + NOTE;
    it.n = it.n.slice(0, 200);
    try { localStorage.setItem('imm_quote', JSON.stringify(a)); } catch (err) { location.href = b.href; return; }
    window.immQuoteRender();
    done(b);
    var nx = document.querySelector('[data-imm-docs] summary') || document.getElementById('imm-docs-h');   // focus stays in the block
    if (nx) { if (!nx.matches('summary')) nx.setAttribute('tabindex', '-1'); nx.focus(); }
    if (window.immToast) window.immToast('Datasheet request added to your quote list &middot; <button type="button" data-imm-qopen>View list (' + a.length + ')</button>');
  });
  // R17: done state is plain text (no href, not focusable, no click)
  function done(el) { el.textContent = '✓ Datasheet requested'; el.removeAttribute('href'); el.setAttribute('tabindex', '-1'); el.setAttribute('aria-disabled', 'true'); el.removeAttribute('data-imm-docask'); el.classList.add('is-done'); }
  // Already asked (note on this product's line): show the done state on load
  var b = document.querySelector('[data-imm-docask]');
  if (!b) return;
  try {
    var a = JSON.parse(localStorage.getItem('imm_quote')) || [];
    if (a.some(function (x) { return x.u === b.getAttribute('data-u') && /datasheet/i.test(x.n || ''); })) done(b);
  } catch (err) {}
})();
